import { Component, ViewEncapsulation, computed, effect, input, signal } from '@angular/core';
import { renderRichText } from '../../../core/utils/render-rich-text.util';

let nextId = 0;

@Component({
  selector: 'ds-faq-item',
  templateUrl: './faq-item.html',
  styleUrl: './faq-item.scss',
  encapsulation: ViewEncapsulation.None,
})
export class FaqItemComponent {
  readonly question = input.required<string>();
  readonly answer = input.required<string>();
  /**
   * Optional DOM id — bound to the wrapping element when provided so callers
   * (e.g. the FAQ archive page) can deep-link directly to this item.
   */
  readonly id = input<string | undefined>(undefined);
  /**
   * Optional externally-controlled open state. When the input transitions to
   * `true` the accordion opens; parents drive hash-deep-link opening via this.
   * FAQP-07 / 24-03 Task 2 depend on this exact surface — option (a) locked.
   */
  readonly open = input<boolean>(false);

  readonly panelId = `faq-panel-${nextId++}`;
  /**
   * Stable per-instance DOM id for the trigger button. Quick-99: the panel's
   * `[attr.aria-labelledby]` references this id so each `<div role="region">`
   * gets a distinct accessible name (the question text inside the trigger),
   * closing axe-core `landmark-unique` on FAQ archive pages. Mirrors the
   * existing `panelId` counter pattern; standard ARIA accordion shape per
   * WAI-ARIA Authoring Practices §3.1.
   */
  readonly triggerId = `faq-trigger-${nextId++}`;
  expanded = signal(false);

  /**
   * Rendered markdown HTML for the answer. Uses `renderRichText` from
   * `src/app/core/utils/render-rich-text.util.ts` — the same utility blog
   * article rendering uses — so markdown (**bold**, lists, links) surfaces
   * as real HTML instead of raw source (FAQP-06).
   */
  readonly renderedAnswer = computed(() => renderRichText(this.answer()));

  constructor() {
    effect(() => {
      if (this.open()) {
        this.expanded.set(true);
      }
    });
  }

  toggle(): void {
    this.expanded.update(v => !v);
  }
}
